export const GET_FAKE_COMMENT = "GET_FAKE_COMMENT";
export const INSERT_FAKE_COMMENT = "INSERT_FAKE_COMMENT";
export const EDIT_FAKE_COMMENT = "EDIT_FAKE_COMMENT";
export const DELETE_FAKE_COMMENT = "DELETE_FAKE_COMMENT";

export const OPEN_COMMENT_DIALOG = "OPEN_COMMENT_DIALOG";
export const CLOSE_COMMENT_DIALOG = "CLOSE_COMMENT_DIALOG";
